import { render } from "./GlobalAIAssistant.vue?vue&type=template&id=8c6e8ad8&scoped=true"
import script from "./GlobalAIAssistant.vue?vue&type=script&lang=js"
export * from "./GlobalAIAssistant.vue?vue&type=script&lang=js"

import "./GlobalAIAssistant.vue?vue&type=style&index=0&id=8c6e8ad8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6e8ad8"]])

export default __exports__